module.exports = __webpack_public_path__ + "img/back-arrow.cfbc6c30.png";